<template lang="pug">
div.table-relatorio-rastreabilidade
    div
        el-table(:data='reports' :empty-text="$t('mensagens.operacao.tabela.vazia')" highlight-current-row="", v-loading="carregandoTabela")
            el-table-column(min-width="120px" prop="reportNumber" :label="$t('mensagens.relatorioRastreabilidade.tabelaListagem.numRelatorio')" sortable)
            el-table-column(prop="culture" :label="$t('mensagens.relatorioRastreabilidade.tabelaListagem.cultura')" sortable)
            el-table-column(align="right" :formatter="formatNumber" prop="reportVolume" :label="$t('mensagens.relatorioRastreabilidade.tabelaListagem.volume')" sortable)
            el-table-column(min-width="120px" prop="reportDate" :label="$t('mensagens.relatorioRastreabilidade.tabelaListagem.dataRelatorio')" sortable)
                template(v-slot="scope")
                    | {{ formatData(scope.row.reportDate) }}
            el-table-column(min-width="120px" prop="status" align="center" :label="$t('mensagens.relatorioRastreabilidade.tabelaListagem.status')" sortable)
                template(v-slot="scope")
                    el-tag(:type="reportStatusColors[scope.row.status].color" style="text-wrap: nowrap" size="mini")
                        | {{ translate(reportStatusColors[scope.row.status].label) }}
            el-table-column(:label="$t('mensagens.comuns.acoes')" align="center")
                template(v-slot="scope")
                    el-dropdown(class="action-button" trigger="click")
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(v-slot="dropdown")
                            el-dropdown-item(v-if="scope.row.status === 'Finalizado'", icon="el-icon-view", @click.native='visualizarReport(scope.row)')
                                | {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.acoes.verRelatorio') }}
                            el-dropdown-item(v-if="scope.row.status === 'Em preenchimento'", icon="el-icon-edit", @click.native='editarReport(scope.row)')
                                | {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.acoes.editar') }}
                            el-dropdown-item(v-if="scope.row.status !== 'Cancelado'", icon="el-icon-delete", @click.native='cancelarReport(scope.row)')
                                | {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.acoes.excluir') }}
                            el-dropdown-item(icon="el-icon-document-copy", @click.native='clonarReport(scope.row)')
                                | {{ $t('mensagens.operacao.acoes.clonar') }}
                            el-dropdown-item(v-if="scope.row.status == 'Finalizado'",icon="el-icon-document", @click.native="visualizarDocumento(scope.row)")
                                | {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.acoes.visualizarDocumento') }}
    div.table-relatorio-rastreabilidade__pagination
        div.total
            span
                | {{ paginacao.totalElements }} {{ $tc('mensagens.relatorioRastreabilidade.tabelaListagem.resultados', paginacao.totalElements) }}
            div(style="margin: 0 20px")
            span
                | {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.visualizacaoPorPagina') }}:
            el-pagination(:current-page="paginacao.page" @size-change='handleSizeChange' :page-sizes="[10, 20, 30, 40]" :page-size="paginacao.size" layout="sizes" :total="paginacao.totalElements")
        div.prev_next
            el-pagination(:current-page="paginacao.page" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]" :page-size="paginacao.size" layout="prev, pager, next, jumper" :total="paginacao.totalElements")

    ModalDeleteReport(
        :report='report',
        :show.sync='mostrarModalCancelamento',
        @cancelarReport='buscarReports(0)'
    )
</template>
<script>
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import EventBus from '@/utils/eventBus';
import formatters from '@/utils/formatters';

export default {
  name: 'ListagemRelatorioRastreabilidade',
  components: {
      ModalDeleteReport: () => import('@/modules/traceability-report/views/pages/main/components/delete-report/content.vue')
  },
  data() {
      return {
          reports: [],
          report: {},
          carregandoTabela: false,
          paginacao: {
              direcao: null,
              size: 10,
              ordernarPor: null,
              page: 0,
              totalPages: 0,
              totalElements: 0
          },
          mostrarModalCancelamento: false,
          reportStatusColors: {
              Finalizado: { color: 'success', label: 'Finalizado' },
              'Em preenchimento': { color: 'warning', label: 'Em preenchimento' },
              Cancelado: { color: 'danger', label: 'Cancelado' }
          },
          filter: {}
      };
  },

  async mounted() {
    await this.buscarReports(this.paginacao.page);
    EventBus.$on('filtered-reports', this.updateReports);
    EventBus.$on('filtered-reports-reportNumber', this.updateReportNumber);
    EventBus.$on('update-filter', this.updateFilter);
  },

  methods: {
        updateReports(data) {
            this.carregandoTabela = true;
            if (data) {
                this.reports = data.content;
                this.carregandoTabela = false;
                this.paginacao.totalElements = data.totalElements;
            }
        },
        updateReportNumber(data) {
            this.carregandoTabela = true;
            if (data) {
                this.reports = data;
                this.carregandoTabela = false;
                this.paginacao.totalElements = 1;
            }
        },
        updateFilter(filter) {
            this.filter = filter;
            this.paginacao.page = 0;
            this.buscarReports(this.paginacao.page);
        },
        translate(key) {
            const chaveNormalizada = this.formatadorDeTexto(key);
            const chaveTraduzida = this.$t(`mensagens.relatorioRastreabilidade.tabelaListagem.statusTag.${chaveNormalizada}`);
            return chaveTraduzida;
        },

        handleSizeChange(size) {
            this.paginacao.size = size;
            this.paginacao.page = 0;
            this.buscarReports(this.paginacao.page);
        },

        handleCurrentChange(page) {
            this.paginacao.page = page;
            const pageToFetch = page - 1;

            this.buscarReports(pageToFetch);
        },

        formatadorDeTexto(texto) {
            return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '-')
                .toUpperCase();
        },

      formatData(data) {
        const dataFormatada = new Date(data).toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
        if (dataFormatada === '01/01/1970') {
            return this.$t('mensagens.relatorioRastreabilidade.tabelaListagem.nenhumaData');
        }
        return dataFormatada;
      },

        editarReport(report) {
            this.$router.push({ name: 'relatorio-rastreabilidade-editar', params: { id: report.id } });
        },

        cancelarReport(report) {
            this.report = report;
            this.mostrarModalCancelamento = true;
        },

        clonarReport(report) {
            this.$router.push({ name: 'relatorio-rastreabilidade-clonar', params: { id: report.id } });
        },

        visualizarReport(report) {
            this.$router.push({ name: 'relatorio-rastreabilidade-visualizar', params: {id: report.id }});
        },

        async visualizarDocumento(row) {
            try {
                const response = await RelatorioRastreabilidadeService.downloadDocument(row.id);
                const blob = new Blob([response.data], {
                    type: 'application/octet-stream'
                });
                const fileURL = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = fileURL;
                a.download = 'document.pdf';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(fileURL);
            } catch (error) {
                this.$notify.error(
                    this.$t('mensagens.relatorioRastreabilidade.erros.document')
                );
            }
        },

        async buscarReports(param) {
            this.carregandoTabela = true;

            const payload = {
                ...this.paginacao,
                ...this.filter,
                page: param
            };
            await RelatorioRastreabilidadeService.filterTraceabilityReport(payload)
                .then(({ data }) => {
                    this.reports = data.content;
                    this.paginacao.page = data.page + 1;
                    this.paginacao.totalElements = data.totalElements;
                    this.paginacao.size = data.size;
                    this.paginacao.totalPages = data.totalPages;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.relatorioRastreabilidade.filtro.searchError')
                    });
                })
                .finally(() => {
                    this.carregandoTabela = false;
                });
        },

        formatNumber(row, column, reportVolume, index) {
            return formatters.formatNumber(reportVolume);
        }
    }
};
</script>
<style scoped lang="scss">
.table-relatorio-rastreabilidade {
  .el-table {
      .cell {
          word-break: break-word !important;
      }

      .action-button {
          cursor: pointer;
      }
  }

  .table-relatorio-rastreabilidade__pagination {
      display: grid;
      grid-template-columns: 2fr auto;
      margin-top: 20px;
      @media (max-width: 768px) {
          grid-template-columns: 1fr;
      }

      .total {
          display: flex;
          align-items: center;
          @media (max-width: 768px) {
              flex-direction: column;
          }
      }

      .prev_next {
          display: flex;
          @media (max-width: 768px) {
              justify-content: center;
              margin-top: 20px;
          }
      }
  }
}
</style>
